import { ToggleButton, styled } from "@mui/material";
import { APP_COLOR, FONT_FAMILY } from "../../../theme";

export const styles = {
    stackLabel:{
        marginBottom: 0,
        fontFamily: FONT_FAMILY,
        fontWeight: "bold",
    }as const,
    modalScale: {
        textTransform: "none",
        fontSize: 14,
        fontFamily: FONT_FAMILY,
      } as const,
}

export const ToggleButtonCustomized = styled(ToggleButton)({
    "&.Mui-selected, &.Mui-selected:hover": {
      color: "white",
      backgroundColor: APP_COLOR,
    },
  });